import { all, call, put, takeEvery } from "redux-saga/effects";

import {
    STROLLERS_ARTICLES_OF_SECTIONS_LOAD_TRIGGER,
    StrollersArticlesOfSectionsLoadApiNormalizedResponse,
    StrollersArticlesOfSectionsLoadTriggerAction,
    strollersArticlesOfSectionsLoadApi,
} from "@/mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSections.actions";
import {
    STROLLERS_GUIDE_SECTIONS_CONFIG,
    STROLLERS_GUIDE_SECTION_RECENT,
} from "@/mk2/apps/strollers/containers/ArticlesOfSections/ArticlesOfSections.constants";
import { XHRAction, XHRGetError, handleXHRGetErrorSaga, normalizeError } from "@/mk2/helpers/api";
import { getLogger } from "@/mk2/logger";
import { HistoryAction } from "@/mk2/services/browserHistory";
import { strollers_api_v2_get_blog_articles_url } from "@/mk/urls/functions";

const logger = getLogger("strollers/ArticlesOfSections.sagas");

interface LoadApiResponse {
    body: {
        entities: StrollersArticlesOfSectionsLoadApiNormalizedResponse["entities"];
        result: StrollersArticlesOfSectionsLoadApiNormalizedResponse["result"];
        hasMore: boolean;
    };
}

function* load({
    sectionSlug,
    after,
    limit,
    xhr,
    history,
}: StrollersArticlesOfSectionsLoadTriggerAction & XHRAction & HistoryAction) {
    yield put(strollersArticlesOfSectionsLoadApi.request(sectionSlug, after, limit));

    try {
        const hashtag =
            sectionSlug === STROLLERS_GUIDE_SECTION_RECENT
                ? STROLLERS_GUIDE_SECTION_RECENT
                : STROLLERS_GUIDE_SECTIONS_CONFIG[sectionSlug].hashtag;
        const response: LoadApiResponse = yield call(() =>
            xhr.get(
                strollers_api_v2_get_blog_articles_url(hashtag, {
                    after,
                    limit,
                }),
            ),
        );

        yield put(
            strollersArticlesOfSectionsLoadApi.success(
                sectionSlug,
                after,
                limit,
                response.body.hasMore,
                {
                    entities: response.body.entities,
                    result: response.body.result,
                },
            ),
        );
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, history, logger);
        yield put(
            strollersArticlesOfSectionsLoadApi.failure(
                sectionSlug,
                after,
                limit,
                normalizeError(error),
            ),
        );
    }
}

export default function* root() {
    yield all([takeEvery(STROLLERS_ARTICLES_OF_SECTIONS_LOAD_TRIGGER, load)]);
}
